import React from 'react';

export default function (props) {
	const { height } = props;
	return (
		<div className="d-flex" style={{ height: `${height}px` }}
			className={props.className}
		>
		 <svg viewBox="0 0 50.1 50.1"
				xmlns="http://www.w3.org/2000/svg"
				
				height={props.height || props.size}>

{/* <title>100 percent matched</title> */}
<g id="Layer_2">
	<g id="Layer_1-2">
		
		<path className="st0" d="M46.7,27.9l2.5,3.6c-0.6,0.4-1.3,0.7-2,1s-1.3,0.6-2,0.9c0.4,1.4,1,2.7,1.4,4.2l-4.3,0.8l0.3,4.3
			c-1.5,0.1-2.9-0.3-4.4-0.3l-0.8,4.3l-4.2-1.5l-1.9,4l-3.6-2.5c-1,1-1.8,2.2-2.9,3.3c-1-1.1-1.9-2.2-2.9-3.3l-3.6,2.5l-1.9-4
			c-1.4,0.4-2.7,1-4.1,1.4c-0.3-1.4-0.5-2.8-0.8-4.3c-1.5-0.1-2.9,0.3-4.4,0.3c0-0.7,0.1-1.5,0.1-2.2s0.1-1.4,0.2-2.2
			c-1.4-0.4-2.8-0.5-4.3-0.9l1.5-4.2l-4-1.9L3.3,28c-1-1-2.2-1.9-3.3-2.9l3.3-2.8c-0.7-1.3-1.6-2.4-2.4-3.7l3.9-1.9l-1.5-4.1
			c1.5-0.4,2.9-0.5,4.3-0.9L7.3,7.4c0.7,0,1.5,0,2.2,0.1l2.2,0.2l0.8-4.3l4.2,1.5l1.9-4l3.6,2.5L25,0c0.5,0.6,1,1.1,1.5,1.7
			s0.9,1.1,1.4,1.7l3.6-2.5l1.9,4l4.1-1.5c0.3,1.4,0.5,2.8,0.8,4.3c1.5,0,2.9-0.3,4.4-0.3l-0.3,4.3c1.4,0.4,2.8,0.5,4.2,0.8
			c-0.2,0.7-0.4,1.4-0.7,2.1c-0.2,0.7-0.5,1.4-0.7,2.1l4,1.9l-2.5,3.6L50,25C49,26.1,47.8,26.9,46.7,27.9z"/>
		<path className="st1" d="M21.1,36c-0.3,0-0.6-0.1-0.9-0.3c-0.2-0.1-0.4-0.3-0.5-0.4l-3.5-3.5l-4.5-4.5c-0.5-0.4-0.8-1-0.7-1.6
			s0.4-1.1,1-1.3c0.2-0.1,0.4-0.1,0.7-0.1c0.4,0,0.7,0.1,1,0.4c0.1,0.1,0.3,0.2,0.4,0.4l0.1,0.1l6.1,6.1c0.1,0.1,0.2,0.2,0.3,0.3
			l0.2,0.2L21,32l0.6-0.6l0.4-0.3l3.1-3.1l13-13c0.2-0.2,0.5-0.4,0.7-0.6c0.2-0.1,0.5-0.2,0.8-0.2c0.9,0,1.7,0.7,1.7,1.7
			c0,0.4-0.1,0.7-0.4,1c-0.1,0.1-0.2,0.2-0.3,0.3l-6.2,6.2l-12,12c-0.2,0.3-0.6,0.5-0.9,0.6C21.4,36,21.3,36,21.1,36z"/>
		
	</g>
</g>
</svg>
<style global jsx>
	{
		`
		.st0{fill:#42A98B;}
		.st1{fill:#FFFFFF;}
		.st3{font-size:25px;}
		.matched-text-box{
			background-color: #42A98B;
			height: 35.5;
			width: 100%;		
		}
		`
		}
	</style>
		</div>	
	)
}


